import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Grid,
  Button,
  TextField,
  Box,
  FormControlLabel,
  FormControl,
  Typography,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { table as tablesData } from "../../../constant/filterMenuItems";
import Header from "../../../components/Header";
import axios from "axios";
import { updatePermissionAction } from "../../../redux/actions/permissionAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import * as yup from "yup";
import { getPermissionActionFn } from "../../../redux/actions/permissionAction";

const validationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  // table: yup.string().required("Table is required"),
  isActive: yup.string().required("Select status"),
});

function EditPermission() {
  const location = useLocation();
  const { pathname } = location;
  const permissionId = pathname.split("/").pop();
  const [err, setErr] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    table: "",
    isActive: "",
  });

  useEffect(() => {
    const fetchPermissionDetails = async () => {
      try {
        const response = await dispatch(getPermissionActionFn(permissionId));

        if (response && response.success) {
          const permissionDetails = response.data;
          setFormData(permissionDetails);
        } else {
          console.log("Failed to fetch permission details");
          toast.error(response.message || "Failed to fetch permission details");
        }
      } catch (error) {
        console.error("Error fetching permission details", error);
        toast.error("Error fetching permission details");
      }
    };

    fetchPermissionDetails();
  }, [permissionId, dispatch]);

  const handleTableChange = (event, value) => {
    const updatedTable = value ? value.value : "";
    setFormData({ ...formData, table: updatedTable });
  };

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await validationSchema.validate(
        { ...formData, table: formData.table },
        { abortEarly: false }
      );
      const updatedFormData = {
        ...formData,
      };

      const response = await dispatch(
        updatePermissionAction(permissionId, updatedFormData)
      );
      console.log("data submitted", response.data);
      if (response) {
        toast.success("Permission edited successfully");
        navigate("/permission");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to edit permission");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [selectedValue, setSelectedValue] = useState("");

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="3.5rem" mr="3.5rem">
      <Header title="EDIT PERMISSION" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth variant="outlined" margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            onBlur={handleBlur}
            value={formData.title}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}{" "}
          {/* TABLE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <Autocomplete
              options={tablesData}
              getOptionLabel={(option) => option.label}
              onChange={handleTableChange}
              value={
                tablesData.find((option) => option.value === formData.table) ||
                null
              }
              renderInput={(params) => <TextField {...params} label="Table" />}
            />
          </FormControl>
          {/* IS ACTIVE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Is Active</InputLabel>
            <Select
              name="isActive"
              onBlur={handleBlur}
              value={formData.isActive}
              onChange={handleChange}
            >
              {/* <MenuItem value="">
                <em>Select</em>
              </MenuItem> */}
              <MenuItem value="true">True</MenuItem>
              <MenuItem value="false">False</MenuItem>
            </Select>
            {err.isActive && (
              <Grid item>
                <Typography color="error">{err.isActive}</Typography>
              </Grid>
            )}{" "}
          </FormControl>
          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
    </Box>
  );
}

export default EditPermission;
